import { HeaderNavbarLinkItem, HeaderNavbarLinks } from '@vueling-ng/vy-ds/src/lib/components/composed/header';
import {
  MegamenuModule,
  MegamenuModuleList
} from '@vueling-ng/vy-ds/src/lib/components/composed/header/megamenu/models';
import {
  ListNavigationItem,
  ListNavigationTypeEnum
} from '@vueling-ng/vy-ds/src/lib/components/globals/list-navigation';
import { GenericMenuItem } from 'app/shared/models/generic-menu-item.model';
import { internalRoutes } from 'environments/common/internal-routes';

const travelInfoKeys = [
  'check-inInformation',
  'accessibility',
  'travelDocuments',
  'baggageInfo',
  'travellingWithChildren',
  'seatInfo'
];

const buildNavigationList = (extraKeys: string[] = []): ListNavigationItem[] =>
  [...travelInfoKeys, ...extraKeys].map((key) => ({
    title: `header_component.infoHelp_megamenu.travel_information.${key}`,
    href: `header_component.infoHelp_megamenu.travel_information.${key}_url`,
    targetBlank: true
  }));

const commonNavigationList = buildNavigationList();
const frenchNavigationList = buildNavigationList(['passengerRights']);

const tripInformationListItems: MegamenuModuleList[] = [
  {
    listType: ListNavigationTypeEnum.PRIMARY,
    listFeatured: true,
    list: [
      {
        title: 'header_component.infoHelp_megamenu.trip_information.helpCenter',
        targetBlank: true,
        href: 'header_component.infoHelp_megamenu.trip_information.helpCenter_url',
        customIcon: 'ds-icon-help'
      },
      {
        title: 'header_component.infoHelp_megamenu.trip_information.ourBundles',
        targetBlank: true,
        href: 'header_component.infoHelp_megamenu.trip_information.ourBundles_url',
        customIcon: 'ds-icon-flight-credit'
      },
      {
        title: 'header_component.infoHelp_megamenu.trip_information.baggageInfo',
        targetBlank: true,
        href: 'header_component.infoHelp_megamenu.trip_information.baggageInfo_url',
        customIcon: 'ds-icon-cabin-bag'
      }
    ]
  },
  {
    listType: ListNavigationTypeEnum.PRIMARY,
    listFeatured: true,
    list: [
      {
        title: 'header_component.infoHelp_megamenu.trip_information.seatInfo',
        targetBlank: true,
        href: 'header_component.infoHelp_megamenu.trip_information.seatInfo_url',
        customIcon: 'ds-icon-seat'
      },
      {
        title: 'header_component.infoHelp_megamenu.trip_information.onboardExperience',
        targetBlank: true,
        href: 'header_component.infoHelp_megamenu.trip_information.onboardExperience_url',
        customIcon: 'ds-icon-coffee'
      },
      {
        title: 'header_component.infoHelp_megamenu.trip_information.whereWeFly',
        targetBlank: true,
        href: 'header_component.infoHelp_megamenu.trip_information.whereWeFly_url',
        customIcon: 'ds-icon-map-pin'
      }
    ]
  }
];

const travelExtrasList: ListNavigationItem[] = [
  'sustainability',
  'parking',
  'transfers',
  'activities',
  'hotels',
  'cars'
].map((key) => ({
  title: `header_component.infoHelp_megamenu.travel_information.${key}`,
  href: `header_component.infoHelp_megamenu.travel_information.${key}_url`,
  targetBlank: true
}));

const buildMegaMenu = (navigationList: ListNavigationItem[]): MegamenuModule[] => [
  {
    id: 'dropdown01',
    title: 'header_component.infoHelp_megamenu.trip_information.title',
    listItems: tripInformationListItems
  },
  {
    id: 'dropdown02',
    title: 'header_component.infoHelp_megamenu.travel_information.title',
    listItems: [
      {
        listType: ListNavigationTypeEnum.DEFAULT,
        listFeatured: true,
        list: navigationList
      },
      {
        listType: ListNavigationTypeEnum.DEFAULT,
        listFeatured: true,
        list: travelExtrasList
      }
    ]
  }
];

const commonMegaMenu = buildMegaMenu(commonNavigationList);
const frenchMegaMenu = buildMegaMenu(frenchNavigationList);

export const infoHelpMenu: HeaderNavbarLinkItem = {
  id: 'navbar07',
  label: 'header_component.infoHelp',
  megamenu: commonMegaMenu
};

export const frenchInfoHelpMenu: HeaderNavbarLinkItem = {
  ...infoHelpMenu,
  megamenu: frenchMegaMenu
};

declare type HeaderComponents =
  | 'home'
  | 'flightStatus'
  | 'blog'
  | 'helpAgencies'
  | 'langCurrencySelectorSidePanel'
  | 'loggedUserMenu';

export const headerData: Record<HeaderComponents, GenericMenuItem> = {
  home: {
    id: 'home',
    label: 'header_component.links.home',
    routerLink: internalRoutes.Home,
    targetBlank: false,
    href: undefined
  },
  flightStatus: {
    id: 'flightStatus',
    label: 'header_component.links.flight_status',
    href: 'header_component.links.flight_status_url',
    routerLink: undefined,
    targetBlank: true
  },
  blog: {
    id: 'blog',
    label: 'header_component.links.blog',
    href: 'header_component.links.blog_url',
    routerLink: undefined,
    targetBlank: true
  },
  helpAgencies: {
    id: 'helpAgencies',
    label: 'header_component.links.help_agencies',
    href: 'header_component.links.help_agencies_url',
    routerLink: undefined,
    targetBlank: true
  },
  langCurrencySelectorSidePanel: {
    label: 'header_component.language_currency_selector.title',
    routerLink: undefined,
    targetBlank: undefined,
    id: undefined,
    href: undefined
  },
  loggedUserMenu: {
    label: 'header_component.logged_user_menu.title',
    routerLink: undefined,
    targetBlank: undefined,
    id: undefined,
    href: undefined
  }
};

const headerNavbarCoreLinkItem: HeaderNavbarLinkItem[] = [
  {
    id: headerData.home.id!,
    label: headerData.home.label,
    routerLink: headerData.home.routerLink!,
    targetBlank: headerData.home.targetBlank
  },
  {
    id: headerData.flightStatus.id!,
    label: headerData.flightStatus.label,
    href: headerData.flightStatus.href!,
    targetBlank: headerData.flightStatus.targetBlank
  }
];

export const headerElementNavbarLinks: HeaderNavbarLinks = {
  leftLinks: headerNavbarCoreLinkItem,
  rightLinks: [
    {
      id: headerData.helpAgencies.id!,
      label: headerData.helpAgencies.label,
      href: headerData.helpAgencies.href!,
      targetBlank: headerData.helpAgencies.targetBlank
    },
    infoHelpMenu
  ]
};

export const headerNavbarAgencyLinkItem: HeaderNavbarLinkItem[] = [
  ...headerNavbarCoreLinkItem,
  {
    id: headerData.blog.id!,
    label: headerData.blog.label,
    href: headerData.blog.href!,
    targetBlank: headerData.blog.targetBlank
  }
];
